/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfilePostWithUserListResponse } from '../../models/profile-post-with-user-list-response';

export interface PromosWeeklyGet$Params {}

export function promosWeeklyGet(
  http: HttpClient,
  rootUrl: string,
  params?: PromosWeeklyGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ProfilePostWithUserListResponse>> {
  const rb = new RequestBuilder(rootUrl, promosWeeklyGet.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProfilePostWithUserListResponse>;
      }),
    );
}

promosWeeklyGet.PATH = '/promos/weekly';
